import { generateApiActions } from './action-helpers';

const types = {
  FETCH_ORGANIZATION_SETTINGS: 'FETCH_ORGANIZATION_SETTINGS',
  CREATE_REQUEST_SOURCE: 'CREATE_REQUEST_SOURCE',
  UPDATE_REQUEST_SOURCE: 'UPDATE_REQUEST_SOURCE',
  DELETE_REQUEST_SOURCE: 'DELETE_REQUEST_SOURCE',
  CREATE_REQUEST_STATUS: 'CREATE_REQUEST_STATUS',
  UPDATE_REQUEST_STATUS: 'UPDATE_REQUEST_STATUS',
  DELETE_REQUEST_STATUS: 'DELETE_REQUEST_STATUS',
  CREATE_REQUEST_LABEL: 'CREATE_REQUEST_LABEL',
  UPDATE_REQUEST_LABEL: 'UPDATE_REQUEST_LABEL',
  DELETE_REQUEST_LABEL: 'DELETE_REQUEST_LABEL',
};

export const {
  fetchOrganizationSettingsRequest,
  fetchOrganizationSettingsSuccess,
  fetchOrganizationSettingsFailure,
} = generateApiActions(types.FETCH_ORGANIZATION_SETTINGS);

export const {
  createRequestSourceRequest,
  createRequestSourceSuccess,
  createRequestSourceFailure,
} = generateApiActions(types.CREATE_REQUEST_SOURCE);

export const {
  deleteRequestSourceRequest,
  deleteRequestSourceSuccess,
  deleteRequestSourceFailure,
} = generateApiActions(types.DELETE_REQUEST_SOURCE);

export const {
  updateRequestSourceRequest,
  updateRequestSourceSuccess,
  updateRequestSourceFailure,
} = generateApiActions(types.UPDATE_REQUEST_SOURCE);

export const {
  createRequestStatusRequest,
  createRequestStatusSuccess,
  createRequestStatusFailure,
} = generateApiActions(types.CREATE_REQUEST_STATUS);

export const {
  deleteRequestStatusRequest,
  deleteRequestStatusSuccess,
  deleteRequestStatusFailure,
} = generateApiActions(types.DELETE_REQUEST_STATUS);

export const {
  updateRequestStatusRequest,
  updateRequestStatusSuccess,
  updateRequestStatusFailure,
} = generateApiActions(types.UPDATE_REQUEST_STATUS);

export const {
  createRequestLabelRequest,
  createRequestLabelSuccess,
  createRequestLabelFailure,
} = generateApiActions(types.CREATE_REQUEST_LABEL);

export const {
  deleteRequestLabelRequest,
  deleteRequestLabelSuccess,
  deleteRequestLabelFailure,
} = generateApiActions(types.DELETE_REQUEST_LABEL);

export const {
  updateRequestLabelRequest,
  updateRequestLabelSuccess,
  updateRequestLabelFailure,
} = generateApiActions(types.UPDATE_REQUEST_LABEL);



// WEBPACK FOOTER //
// ./src/redux/actions/organization-settings.js